module.exports = function() {
  return new Worker("/" + "babel-transpiler.d500c055.worker.js");
};